import PropTypes from 'prop-types'

const SpeiInstruction = (props) => <div className='instruction-box'>
  <div className='instruction-badge'>{props.label}</div>
  {props.text}
</div>

SpeiInstruction.propTypes = {
  label: PropTypes.number,
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ])
}
export default SpeiInstruction
